import React from "react";
import BoxLoader from "../../general/boxLoader";
import EmptyBox from "../../general/emptyBox";
import ScheduleCardsBoxItem from "./scheduleCardsBox_item";

const ScheduleCardsBox = ({
  dataList,
  dataListTitles,
  isRequesting
}) => {
    const _dataList = dataList?.data && dataList?.data.length > 0 && dataList?.data.map((item, i) => {
      return <ScheduleCardsBoxItem item={item} dataListTitles={dataListTitles} key={i} />
    })
  return(
    <div>
      { isRequesting ? <BoxLoader /> : _dataList ? _dataList : <EmptyBox /> }
    </div>
  )
}

export default ScheduleCardsBox;